// @parsleyai/feature-flags — the browser-safe, SDK-free registry of feature flags, shared by every
// package that touches one: web reads them, the admin tool renders and writes them, and functions
// validates the key on write. Holds no Firebase SDK, so the web and admin bundles can import it.
//
// Flags live at `feature_flags/{flagKey}` in Firestore, written only by the adminSetFeatureFlag
// callable. This package knows nothing about that — it owns the closed set and the fail-safe
// defaults, and leaves reading to whoever has a Firestore client.
//
// Built as CommonJS because functions require() it, so the browser bundles take the TypeScript
// source instead: web via the `parsley-source` export condition, admin via a Vite alias. Vite's dev
// pipeline can't expose a linked CJS barrel's named exports to native ESM.

export {
  FEATURE_FLAG_KEYS,
  FEATURE_FLAGS,
  FeatureFlag,
  type FlagDefinition,
  isFeatureFlag,
  resolveFlag
} from './registry'

/** The Firestore collection holding one document per overridden flag. */
export const FEATURE_FLAGS_COLLECTION = 'feature_flags'
